import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  container: {
    margin: 12,
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    borderWidth: 1,
    borderColor: '#d1d5db',
    borderRadius: 8,
    padding: 10,
    marginBottom: 10,
    backgroundColor: '#f9fafb',
  },
  title: {
    fontSize: 13,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginBottom: 8,
    textAlign: 'center',
    color: '#111827',
  },
  row: {
    flexDirection: 'row',
    marginBottom: 4,
  },
  label: {
    fontSize: 9,
    fontWeight: 'bold',
    marginRight: 4,
    color: '#374151',
  },
  value: {
    fontSize: 9,
    color: '#111827',
    flex: 1,
  },
  tableHead: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#d1d5db',
    backgroundColor: '#ecfdf5',
    paddingVertical: 6,
    paddingHorizontal: 4,
  },
  tableHeadText: {
    fontSize: 8,
    fontWeight: 'bold',
    color: '#14532d',
  },
  tableRow: {
    flexDirection: 'row',
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#d1d5db',
    paddingVertical: 5,
    paddingHorizontal: 4,
  },
  tableCell: {
    fontSize: 8,
    color: '#111827',
  },
  colDate: {
    width: '14%',
  },
  colTime: {
    width: '12%',
  },
  colStatus: {
    width: '16%',
  },
  colRank: {
    width: '12%',
  },
  colObservation: {
    width: '46%',
  },
});
